import { useEffect, useRef, useState } from "react";
import {  getFontSizeFromWidthAndStyle } from "vagaro-website-rendering/src/components/Utilities/FontScalingUtils";
import { SiteStyling } from "vagaro-website-rendering/src/components/Definitions/SiteStyling";

import { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { BreakPoints } from "vagaro-website-rendering/src/components/Utilities/BreakPoints";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";




export default function CanvasFontScaleObserver({screenSize, siteStyling, cssTarget}:{screenSize:ScreenSize, siteStyling:SiteStyling,cssTarget?:string }) {
    let t = cssTarget??"#v-canvas";

    //passing by ref is inconsistant so we are using a state
    let canvasDom = useRef<HTMLElement>( document.querySelector(t) as HTMLElement);

    const [canvasWidth, setCanvasWidth] = useState(canvasDom.current.clientWidth);


    useEffect(() => {
        const observer = new ResizeObserver(() => {
            window.requestAnimationFrame(() => {
                 let newWidth = canvasDom.current.getBoundingClientRect().width;

                 if (newWidth !== canvasWidth) {
                     setCanvasWidth(newWidth);


                 }
             });

         });
        if (canvasDom.current) {
        observer.observe(canvasDom.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [canvasDom]);





    return <>

    <style id="font-scaling-styling" >
        {GetCanvasFontScaleCSS(siteStyling,canvasWidth,screenSize)}
    </style></>

}

export function GetCanvasFontScaleCSS(siteStyling:SiteStyling,viewportWidth:number,screenSize:number = -1) {

    if(!siteStyling.useFontScaling){
        return `
        #v-canvas, .grid-dragging-wrapper {
            font-size: ${siteStyling.desktopFontSize}px !important;
        }
        `;
    }

    return `
    #v-canvas, .grid-dragging-wrapper {
        font-size: ${getFontSizeFromWidthAndStyle(viewportWidth,siteStyling,screenSize)} !important;
    }
    `;
}